export function OutlineMailIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.08 5H4.92C3.85961 5 3 5.85961 3 6.92V17.0816C3 18.142 3.85961 19.0016 4.92 19.0016H19.08C20.1404 19.0016 21 18.142 21 17.0816V6.92C21 5.85961 20.1404 5 19.08 5Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7.00195L12 13.002L21 7.00195"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
